import URL from "../config/api";
import axios from "../config/axios";

const HEARTBEAT_INTERVAL_MS = 30000;
// Id do módulo Gameficandus em configuration_modules. Vale para produção e
// homologação — o 114 que circulou nas specs de julho/2026 nunca existiu na
// tabela, e por isso o gate reprovava todo mundo.
export const GAMEFICANDUS_MODULE_ID = 62;

export const hasGameficandusModule = userModules =>
  Array.isArray(userModules) &&
  userModules.some(module => module.id === GAMEFICANDUS_MODULE_ID);

export class AccessSessionTracker {
  constructor() {
    this.sessionId = null;
    this.token = null;
    this.itemType = null;
    this.itemId = null;
    this.intervalId = null;
    this._starting = false;
    this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
    this.handlePageHide = this.handlePageHide.bind(this);
  }

  start(itemType, itemId, token) {
    if (this._starting || this.sessionId) {
      return;
    }

    this.itemType = itemType;
    this.itemId = itemId;
    this.token = token;
    this._starting = true;

    axios
      .post(
        `${URL.api}gamification/access-sessions/start`,
        { item_type: itemType, item_id: itemId },
        { headers: { authorization: `Bearer ${token}` } }
      )
      .then(resp => {
        this._starting = false;
        if (resp.data.success) {
          this.sessionId = resp.data.data.session_id;
          this.intervalId = setInterval(
            () => this.sendHeartbeat(),
            HEARTBEAT_INTERVAL_MS
          );
          document.addEventListener(
            "visibilitychange",
            this.handleVisibilityChange
          );
          window.addEventListener("pagehide", this.handlePageHide);
        }
      })
      .catch(() => {
        this._starting = false;
      });
  }

  sendHeartbeat() {
    if (!this.sessionId || document.visibilityState !== "visible") {
      return;
    }

    axios
      .post(
        `${URL.api}gamification/access-sessions/heartbeat`,
        { session_id: this.sessionId },
        { headers: { authorization: `Bearer ${this.token}` } }
      )
      .catch(() => {});
  }

  handleVisibilityChange() {
    if (document.hidden) {
      this.sendEndBeacon();
    } else if (!this.sessionId && this.itemType !== null) {
      this.start(this.itemType, this.itemId, this.token);
    }
  }

  handlePageHide() {
    this.sendEndBeacon();
  }

  sendEndBeacon() {
    if (!this.sessionId) {
      return;
    }

    const payload = JSON.stringify({
      session_id: this.sessionId,
      token: this.token
    });
    const blob = new Blob([payload], { type: "application/json" });
    navigator.sendBeacon(`${URL.api}gamification/access-sessions/end`, blob);

    this.sessionId = null;
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  stop() {
    this.sendEndBeacon();

    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );
    window.removeEventListener("pagehide", this.handlePageHide);

    this.itemType = null;
    this.itemId = null;
    this.token = null;
  }
}
